import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function InsertEmoticonIcon(props: IconProps) {
    return <Icon {...props} iconKey={"insert_emoticon"}/>
}
